import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="text-center notfound" >
      <h1 className="display-1 text-warning">404</h1>
      <p className="lead text-warning">Lo sentimos, la página que buscás no existe.</p>
      <Link className="btn btn-dark text-warning" to="/">Volver al inicio</Link>
    </div>
  );
}

export default NotFound;
